// Per-user localStorage / cloud-backup keys. Centralized so a typo in
// one tab can't desync from the load effect that hydrates state.

export const K = {
  transactions: 'tx_all_v1',
  producers: 'cfg_producers_v1',
  settings: 'cfg_settings_v1',
  payouts: 'payouts_history_v1',
  uploads: 'uploads_log_v1',
  clientNotes: 'client_notes_v1',
  presentationConfig: 'presentation_config_v1',
  policyTracking: 'policy_tracking_v1',
  clientProfiles: 'client_profiles_v1',
  lobConfig: 'lob_config_v1',
  pipeline: 'pipeline_v1',
  calendar: 'calendar_v1',
  vaTimeLogs: 'va_time_logs_v1',
  vaTasks: 'va_tasks_v1',            // manually-added VA tasks (one-offs)
  vaTaskDone: 'va_task_done_v1',     // completion records for any task (auto OR manual)
  commissionRules: 'commission_rules_v1', // Phase 2 SaaS — configurable payout rules
  carrierCatalog:  'carrier_catalog_v1',  // Phase 3 SaaS — configurable carrier + product detection
  callKpis: 'call_kpis_v1',          // legacy — read-only, migrated to calls
  calls: 'calls_v1',                  // individual call records (replaces callKpis)
  leads: 'cfg_leads_v1',              // per spec — was 'leads_v1' in earlier build
  leadsLegacy: 'leads_v1',            // legacy fallback for one-time migration
  outreach: 'cfg_outreach_v1',        // per-lead contact attempts
  leadTemplates: 'leadTemplates',     // SMS/email message templates
  workflows:     'workflows_v1',      // Customizable AI conversation workflows (texting clients, booking appointments)
  conservation:  'conservation_v1',   // MOO Policy Conservation Opportunities events — the save-the-policy worklist
  customTeams:   'custom_teams_v1',   // Operator-defined team labels; each producer carries a customTeam ref
  goalConfig:    'goal_config_v1',    // FEX Goal Engine — monthly target + funnel assumptions
  fexOnboarding: 'fex_onboarding_v1', // Phase 0-4 onboarding checklist state {phase:{idx:bool}}
  onboardingChat: 'onboarding_chat_v1', // persisted AI onboarding conversation (messages array)
  onboardingDismissed: 'onboarding_dismissed_v1', // user explicitly skipped onboarding
  saveTasks: 'save_tasks_v1', // per-task VA call queue status + AI-generated scripts {taskId:{status,aiScript,calledAt,notes}}
  inboxReadState: 'inbox_read_state_v1', // {leadId: {lastReadAt: ISO}} — tracks which conversations have been read
  acknowledgedWelcomes: 'acknowledged_welcomes_v1', // [policyKey] — policies the operator has already welcomed or dismissed; drives the New-Client Welcome panel on Home so the same row doesn't keep reappearing.
  financialConfig: 'financial_config_v1', // CFO Dashboard inputs — overhead, advance %, renewal %, LTV horizon, enterprise multiple
  apps: 'apps_v1', // Underwriting pipeline — submitted apps with status + pending requirements
  accountantChat: 'accountant_chat_v1', // 💼 AI Accountant conversation transcript
  // Client Lifecycle (Phase 1) — local cache of the clients table so
  // the Clients tab opens instantly without waiting on a round trip.
  // Authoritative store is public.clients in Supabase; this is a hint.
  clientLifecycleCache: 'client_lifecycle_cache_v1',
};
